export default "__VITE_ASSET__BXXbv3bR__"